import { Component, computed, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EngagementType } from 'interfaces/data/engagement-grid-container-page';
import { CommonEngagementGridPart } from '../../../../../ui/widget';
import { AdmissionsEngagementsService, } from '../../admissions-engagements.service';

@Component({
	selector: 'admissions-completed-engagements-view-part',
	standalone: true,
	imports: [CommonEngagementGridPart],
	templateUrl: './completed-engagements-view.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./completed-engagements-view.part.scss'],
})
export class AdmissionsEngagementsCompletedEngagementsViewPart implements OnInit {

	public readonly pageService = inject(AdmissionsEngagementsService);
	public engagements = computed(() => (this.pageService.engagements() || []).filter(t =>
		t.closedUTC
	));

	ngOnInit() {
		this.pageService.engagementType.set(EngagementType.closed);
	}
}